const SOURCE = {
  WORKSHEET: 'worksheet'
}

const CUSTOM_ACTION_NAME = 'Custom action'

export { CUSTOM_ACTION_NAME, SOURCE }
